export default "__VITE_PUBLIC_ASSET__578d2c3a__"